import React from "react";
import GeneralBilling from "./GeneralBilling";

/**
 * Billing component - Manages billing functionality for legal matters
 * Uses the unified GeneralBilling component with matter-specific endpoints
 */
const Billing: React.FC = () => {
  return <GeneralBilling />;
};

export default Billing;
